import { render, staticRenderFns } from "./BatchSelects.vue?vue&type=template&id=3a1fdd88&"
import script from "./BatchSelects.vue?vue&type=script&lang=js&"
export * from "./BatchSelects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports